export default {
  PROOF_OF_ADDRESS_REPOSITORY: Symbol.for('PROOF_OF_ADDRESS_REPOSITORY'),
  USE_INE_AS_PROOF_OF_ADDRESS_COMMAND: Symbol.for('USE_INE_AS_PROOF_OF_ADDRESS_COMMAND'),
};
